






































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Mutation, Action } from "vuex-class";
import Vuei18n from "@/i18n";

import { MUTATIONS, ACTIONS } from "@/models/vuex-types";

import { EventStatus, Event } from "../models/event";
import { WishifyUser } from "@/models/wishify-user";
import { UserProfile } from "@/models/profile";

@Component({
  components: {

  },
})
export default class EventEditCard extends Vue {
  @State private userProfile: UserProfile;
  @State private currentUser: WishifyUser;
  @State private locale: string;

  @Prop({ default: new Event("", "", "", "", EventStatus.NEW, "", "", "", "", "") }) private currentEvent: Event;
  @Prop({ default: false }) private isEventLoading: boolean;
  @Prop({ default: false }) private isEventModified: boolean;

  private isDatePickerOpened = false;
  private isThemePickerVisible = false;
  private isConfirmationForSendVisible = false;
  private isShareConfirmationVisible = false;
  private isFormValid = true;

  private removeEmailFromList(item: any): void {
    this.currentEvent.contributors.splice(this.currentEvent.contributors.indexOf(item), 1);
    this.currentEvent.contributors = [...this.currentEvent.contributors];
    this.onContributorsInput();
  }

  private areContributorsValid() {
    return this.currentEvent.contributors.every((email) => this.isEmailValid(email)) || Vuei18n.t("wrong_email_addresses").toString();
  }

  private isEmailValid(email: string) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  private onContributorsInput() {
    // vuetify method to run validation on all inputs inside v-form
    this.$emit("onInput", { isFormValid: (this.$refs.profileForm as any).validate() });
  }
}
